module.exports = __webpack_public_path__ + "media/images/red-account-multiple-7ebca126255529f66818700622dcd5b5.svg";